export default __webpack_public_path__ + "static/12-7b2841cf57f01df86e078fda8391a435.webp";